import {capitalize} from '@mui/material';

import {translations} from 'presentation/translations-new';
import {GuideStep} from './constants';

const {details, results, appointmentCity} = translations['pt-br'].commons;

const MOBILE_STEPS_LABELS = {
	[GuideStep.LOCATION]: appointmentCity,
	[GuideStep.DETAILS]: details,
	[GuideStep.RESULTS]: capitalize(results),
};

export {MOBILE_STEPS_LABELS};
